







































import { Component, Prop, Emit, PropSync, Ref, Mixins, Watch } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import Modals from '@ustra/nuxt/src/vue/mixins/modal'

@Component
export default class extends Mixins(Modals, HsComponent) {
  // #region variables
  @Prop({ default: null }) readonly headerTitle: string
  @Prop({ default: null }) readonly contentTitle: string
  @Prop({ default: '메세지 내용' }) readonly message: string
  @Prop({ default: null }) contentAlign: string
  @Prop({ default: null }) bodyBgColor: string
  @Prop({ default: null }) styleClass: string
  @Prop({ default: null }) readonly agreeLabel: string
  @Prop({ default: null }) readonly cancelLabel: string
  @Prop({ default: null }) readonly initLabel: string
  @Prop({ default: 500 }) readonly width: number
  @Prop({ default: 200 }) readonly height: number
  @Prop({ default: 202 }) readonly zIndex: number
  @Prop({ default: false }) readonly isFullscreen: boolean
  @Prop({ default: true }) readonly persistent: boolean
  @PropSync('visible', { default: false }) syncVisible: boolean
  @Ref() hsDialog

  hide() {
    // console.log('Modal hide --------------', this.syncVisible, this.headerTitle, this.message)
    this.syncVisible = false
  }

  // beforeCreate() {
  //   console.log('Modal beforeCreated --------------', document.getElementsByClassName('v-dialog__content--active').length)
  // }

  // created() {
  //   console.log('Modal created --------------', this.syncVisible, this.headerTitle, this.message)
  // }

  mounted() {
    // console.log(
    //   'Modal mounted -----------------',
    //   this.syncVisible,
    //   this.headerTitle,
    //   this.message,
    //   document.getElementsByClassName('v-dialog__content--active').length,
    //   document.querySelector('html').classList
    // )
    this.$nextTick(function () {
      const modal = document.getElementsByClassName('v-dialog__content--active').length
      // console.log('modal -----------------------------------', modal)
      if (modal > 0) {
        setTimeout(() => document.documentElement.classList.add('overflow-y-hidden'), 400)
      } else {
        setTimeout(() => document.documentElement.classList.remove('overflow-y-hidden'), 400)
      }
    })
  }

  // updated() {
  //   console.log('Modal update --------------', this.syncVisible, this.headerTitle, this.message)
  // }

  // destroyed() {
  //   console.log(
  //     'Modal destroy-----------------',
  //     this.syncVisible,
  //     this.headerTitle,
  //     this.message,
  //     document.getElementsByClassName('v-dialog__content--active').length,
  //     document.querySelector('html').classList
  //   )
  // }

  @Emit()
  click(result: boolean) {
    // console.log('Modal click --------------', result)
    this.syncVisible = false
  }

  @Emit()
  init() {
    // console.log('Modal init --------------')
  }

  onClickOutside() {
    // console.log('Modal onClickOutside -----------------', this.syncVisible, document.getElementsByClassName('v-dialog__content--active').length, document.querySelector('html').classList)
    if (this.persistent) this.$nextTick(() => document.documentElement.classList.add('overflow-y-hidden'))
  }

  scrollLock(value) {
    if (value) {
      this.$nextTick(function () {
        document.documentElement.classList.add('overflow-y-hidden')
      })
    } else {
      this.$nextTick(function () {
        const modal = document.getElementsByClassName('v-dialog__content--active').length
        if (modal > 1) {
          document.documentElement.classList.add('overflow-y-hidden')
        } else {
          document.documentElement.classList.remove('overflow-y-hidden')
        }
      })
    }
  }

  // #region watches
  @Watch('syncVisible')
  valueChanged(value: boolean) {
    // console.log(
    //   'Modal visible Watch-----------------',
    //   this.syncVisible,
    //   this.headerTitle,
    //   this.message,
    //   document.getElementsByClassName('v-dialog__content--active').length,
    //   document.querySelector('html').classList
    // )
    if (value) {
      // @ts-ignore
      Modals.options.methods._showModal.call(this)
    } else {
      // @ts-ignore
      Modals.options.methods._hideModal.call(this)
    }
    setTimeout(() => this.scrollLock(value), 200)
  }
  // #endregion
}
